<div class="row messaging">
  <div class="col-md-1"></div>
  <div class="col-md-10">
    <div class="row" *ngIf="errorMessage">
      <div
        class="alert alert-danger"
        role="alert"
        [innerHTML]="errorMessage"
      ></div>
    </div>
    <div class="row" *ngIf="successMessage">
      <div
        class="alert alert-success"
        role="alert"
        [innerHTML]="successMessage"
      ></div>
    </div>
  </div>
</div>
